import { Component, OnInit } from '@angular/core';
import { SlideInOutAnimation } from './animations';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { Router } from '@angular/router';
import { TimeSheetService } from 'src/app/services/time-sheet.service';
import { UtilityService } from '../../services/utility.service'
import { months } from '../../_models/staticArray'

const moment = extendMoment(Moment);


@Component({
  selector: 'app-week-list',
  templateUrl: './week-list.component.html',
  styleUrls: ['./week-list.component.scss'],
  animations: [SlideInOutAnimation]
})
export class WeekListComponent implements OnInit {

  months = months
  // [{ id: '0', name: 'January' }, { id: '1', name: 'February' }, { id: '2', name: 'March' }, { id: '3', name: 'April' }, { id: '4', name: 'May' }, { id: '5', name: 'June' },
  // { id: '6', name: 'July' }, { id: '7', name: 'August' }, { id: '8', name: 'September' }, { id: '9', name: 'October' }, { id: '10', name: 'November' }, { id: '11', name: 'December' }]

  animationState = 'out';
  testId: any;
  show: Boolean = false;
  index;
  loading: Boolean = false;
  dateOfWeek = [];
  allWeeks = [];
  hideme = [];
  panelOpenState = false;
  step: number;
  currentUser;
  instructorId;
  instByAdmin: any;
  notEnfData;
  user: any;
  instructorUserId: any;
  selectedMonth: any;
  allRailWeeks: any;
  currentYear = moment().year()

  constructor(private router: Router, private _timeSheetService: TimeSheetService, public _utilityService: UtilityService) {
    if (this.router.getCurrentNavigation().extras.state) this.instByAdmin = this.router.getCurrentNavigation().extras.state.instructor;
    // if (this.router.getCurrentNavigation().extras.state.instructor) console.log(this.router.getCurrentNavigation().extras.state.instructor);
  }

  ngOnInit() {
    this.getWeeknumberwithDates();
    if (this.instByAdmin != undefined) {
      this.instructorId = this.instByAdmin
      console.log("this.instructorId", this.instructorId);
    }
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    console.log("User role", this.user);

    if (this.user.isTrainer || this.user.isMp || this.user.isStaff || this.user.isIQA || this.user.isOperative) this.instructorId = this.currentUser._id
    if (this.user.isTrainer || this.user.isMp || this.user.isStaff || this.user.isIQA || this.user.isOperative) this.instructorUserId = this.currentUser.userId
    console.log("this.instructorId", this.instructorId, "this.instructorUserId", this.instructorUserId);
  }


  showCurrentMonthWeeks(month, i) {
    console.log("showCurrentMonthWeeks", month, i)
    this.step = i
    this.selectedMonth = month
    // console.log("WHAT IS THE MONTH", month, i);
    // console.log("CURRENT YEAR", moment().year())
    let year = moment().year()
    let monthWeeks = []
    this.allRailWeeks.filter((x) => {
      if ((Number(x.month) === (Number(month) + 1)) && (Number(x.year) === Number(year))) {
        console.log("WHAT IS THE SINGLE WEEK DATA", x, year)
        // console.log("THIS IS THE SELECTED MONTH WEEK", x)
        let obj = {
          weekNumber: x.weekNumber, weekStartDate: x.startDate, weekEndDate: x.endDate,
          from: moment(x.startDate).format('DD/MM/YYYY'),
          to: moment(x.endDate).format('DD/MM/YYYY'),
          bothDates: "From: " + moment(x.startDate).format('DD/MM/YYYY') + " - " + "To: " + moment(x.endDate).format('DD/MM/YYYY'),
          dateList: x.dateList
        }
        monthWeeks.push(obj)
        // x
      }
    })
    this.allWeeks = monthWeeks
  }



  showWeeks(month, i) {
    console.log("WHAT IS THE MONTH", month, i);

    this.step = i;
    return new Promise((resolve, reject) => {
      this.allWeeks = [];
      let year = moment().year()
      let startDate = moment.utc([year, month])
      let monthStart = moment(startDate).startOf('month')
      let monthEnd = moment(startDate).endOf('month')
      this.selectedMonth = month
      console.log("monthStart =------ ", monthStart, i);



      let monthStartWeekNumber = moment(monthStart).isoWeek()
      let monthEndWeekNumber = moment(monthEnd).isoWeek()
      console.log("monthStartWeekNumber", monthStartWeekNumber, "monthEndWeekNumber", monthEndWeekNumber);
      if (monthStartWeekNumber == 53) monthStartWeekNumber = 1
      if (monthEndWeekNumber == 1) monthEndWeekNumber = 52
      if (monthStartWeekNumber == 53) monthStartWeekNumber = 1
      for (let i = monthStartWeekNumber; i <= monthEndWeekNumber; i++) {
        console.log("in loop", i);
        let weekStartDate = moment().startOf('isoWeek').isoWeek(i);
        if (i == 1 && weekStartDate < moment().startOf('year')) weekStartDate = moment().startOf('year');
        // let weekEndDate = moment('2020').startOf('week').day('Saturday').week(i);
        let weekEndDate = moment().endOf('isoWeek').isoWeek(i);
        // console.log("weekEndDate", weekEndDate.date(), weekEndDate.month());
        if (weekEndDate > moment().endOf('year')) {
          // console.log("weekEndDate > moment().endOf('year')", weekEndDate, moment().endOf('year'));
          weekEndDate = moment().endOf('year')
        }
        this.allWeeks.push({ weekNumber: i, weekStartDate: weekStartDate, weekEndDate: weekEndDate })
        console.log("weekNumber: i", i, "weekStartDate", weekStartDate, "weekEndDate", weekEndDate);
      }
      this.show = true;
      console.log("$$allWeeks", this.allWeeks);
      resolve(this.allWeeks)
    }).then((resolvedAllWeeks) => {
      console.log("---resolvedAllWeeks-- in AFTER FOR LOOP", resolvedAllWeeks);
      this.getStatus(resolvedAllWeeks).then((resolvedWeeks: any) => {
        console.log("$$resolvedWeeks-----", resolvedWeeks, this.allWeeks);
        this.loading = false
      })
    })
    // this.index = i;
  }
  getWeekDates(week) {
    console.log("-----getWeekDates-----", week);
    let dates = []
    // return new Promise((resolve,reject)=>{
    dates.push(week.weekStartDate.format('MM/DD/YYYY'))
    return new Promise((resolve, reject) => {
      while (week.weekStartDate.add(1, 'days').diff(week.weekEndDate) < 0) {
        console.log("In while loop");
        console.log(week.weekStartDate.toDate());
        dates.push(week.weekStartDate.clone().format('MM/DD/YYYY'));
      }
      resolve(dates)
    })
    console.log(" AFTER WHILE **dates", dates);
    // resolve(dates)
    // })
    // console.log("*****dates:", dates);
    // this.router.navigate(['action-selection'], { state: { example: 'bar' } });
    // this.router.navigate(['single-week'], { state: { datesOfTheWeek: dates } })
  }
  getStatus(weeks) {
    this.loading = true;
    console.log("-----getStatus-----", weeks);
    return new Promise((resolve, reject) => {
      let tempdatesArrayResolved = []
      weeks.forEach((singleWeek) => {
        console.log("singleWeek", singleWeek);
        this.getWeekDates(singleWeek).then((datesArrayResolved: any) => {
          // tempdatesArrayResolved = datesArrayResolved
          console.log("datesArrayResolved", datesArrayResolved);
          // console.log("-------datesArrayResolved---------", datesArrayResolved);
          singleWeek['datesOfTheWeek'] = datesArrayResolved;
          singleWeek.weekStart = datesArrayResolved[0]
          singleWeek.weekEnd = datesArrayResolved[datesArrayResolved.length - 1]
          //       console.log("datesOfTheWeek", singleWeek.datesOfTheWeek);
          tempdatesArrayResolved.push(datesArrayResolved)

        })
        console.log("******tempdatesArrayResolved", tempdatesArrayResolved);
        resolve(tempdatesArrayResolved)
      })
      // console.log("******tempdatesArrayResolved", tempdatesArrayResolved);
      //   console.log("after API call", weeks);

    })
  }
  singleWeek(week) {
    console.log("ALL DATES ARRAY", week.datesOfTheWeek);

    console.log("this.instructorId====>>>>>", this.instructorId);
    this.router.navigate(['/timesheet/user-single-week'], { queryParams: { month: this.selectedMonth, weekNumber: week.weekNumber, instructorId: this.instructorId, userId: this.instructorUserId, type: 'adminSheet' } })

  }
  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }
  panelClosed(event) {
    console.log("event", event);
  }
  // setStep(index: number) {
  //   this.step = index;
  // }

  getWeeknumberwithDates() {
    this._timeSheetService.getRailWeekDates({}).subscribe((data) => {
      this.allRailWeeks = data
      console.log("THIS IS THE LIST OF WEEK DATES", this.allRailWeeks)
    }, error => {
      console.log("ERROR WHILE GET WEEK DATES", error)
    })
  }
}
